import { useAgreementsData } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/hooks/useAgreementsData'

import { Base } from './Base'
import { CustomChildrenProps } from './props'

export const Agreements = ({
  id,
  level,
  groupBy,
  headerLength,
  tableHeadRef,
  parentHasItemWithChildren,
  setParentHasItemWithChildren,
}: CustomChildrenProps) => {
  return (
    <Base
      id={id}
      level={level}
      type="agreements"
      groupBy={groupBy}
      hook={useAgreementsData}
      headerLength={headerLength}
      tableHeadRef={tableHeadRef}
      parentHasItemWithChildren={parentHasItemWithChildren}
      setParentHasItemWithChildren={setParentHasItemWithChildren}
    />
  )
}
